module.exports = __webpack_public_path__ + "static/media/img_image@2x.5529ccef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_image@2x.jpg
// module id = 1011
// module chunks = 0